import type { MiniLot } from '$mapapp/types/miniLot'

export type States = 'results' | 'result' | 'secondary'
export type MatchingSetEvents = 'set_results' | 'set_result' | 'set_secondary'
export type MatchingOptions = {
	profileId?: string
	radius?: { from: number; to: number }
	miniLot?: MiniLot
}

/**
 * canonical markerId built from a partner's type+id.
 *
 * SSOT for the `matches` map key AND lookups into `appState.allMarkers`. both
 * must use this format so internal lookups intersect with the global marker
 * registry without an intermediate transform. backend DTO contract:
 * `MatchOverviewPartnerDto` exposes `objType: 'lot' | 'pop'` and `objId: string`
 */
export const toMarkerId = (objType: string, objId: string): string => `${objType}-${objId}`

/**
 * id of the maplibre GeoJSON source rendered by LayerMatchingRadius. it lives here rather than in
 * the layer so the camera code can read the source's bounds without importing a component, and so
 * neither of them has to import the matching store for one string
 */
export const MATCHING_RADIUS_SRC = 'matching-radius-src'
